<template>
  <div class="tool_main">
    <textarea
      class="t9text"
      v-model="testtitle"
      v-sliceString="titleMaxLength"
      width="100%"
      placeholder="请输入要说的话..."
    ></textarea>
    <div class="row" style="">
      <div class="emotion" @mouseover="mouseOver" @mouseleave="mouseLeave">
        <i class="iconfont icon-smile"></i>
        <div class="emotion_list" v-show="qingxulist">
          <span
            v-for="(ifc, i) in myemoji"
            :key="i + 'face'"
            @click="selface(ifc)"
            ><icon-face :iconClass="ifc.face"></icon-face><br />{{
              ifc.text
            }}</span
          >

          <span @click="selface('')"
            ><i
              class="iconfont icon-guanbi"
              style="font-size: 21px; line-height: 31px"
            ></i
            ><br />
            取消</span
          >
        </div>
        <span>{{ face.text }}</span>
      </div>

      <div class="textlen">{{ testtitle.length }}/{{ titleMaxLength }}</div>
    </div>
    <div class="row" v-if="this.ttsrole.emotion.length > 0 && false">
      <div class="rowtitle">情绪</div>
      <div class="emotion" @mouseover="mouseOver" @mouseleave="mouseLeave">
        <i class="iconfont icon-smile"></i>
        <div class="emotion_list" v-show="qingxulist">
          <span
            v-for="(ifc, i) in myemoji"
            :key="i + 'face'"
            @click="selface(ifc)"
            ><icon-face :iconClass="ifc.face"></icon-face><br />{{
              ifc.text
            }}</span
          >

          <span @click="selface('')"
            ><i
              class="iconfont icon-guanbi"
              style="font-size: 21px; line-height: 31px"
            ></i
            ><br />
            取消</span
          >
        </div>
        <span>{{ face.text }}</span>
      </div>
    </div>

    <div class="row" v-show="face.hasOwnProperty('id')">
      <div class="rowtitle">强度</div>
      <div class="rowslider">
        <vue-slider
          v-model="qiangdu"
          :interval="0.1"
          :min="0"
          :max="1.2"
          key=""
          :dot-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
          :process-style="{ backgroundColor: 'pink' }"
          :tooltip-style="{ backgroundColor: 'pink', borderColor: 'pink' }"
        ></vue-slider>
      </div>
    </div>

    <div class="row">
      <div class="rowtitle">语速</div>
      <div class="rowslider">
        <vue-slider
          v-model="yusu"
          :interval="0.1"
          :min="0"
          :max="3"
          key=""
          :dot-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
          :process-style="{ backgroundColor: 'pink' }"
          :tooltip-style="{ backgroundColor: 'pink', borderColor: 'pink' }"
        ></vue-slider>
      </div>
    </div>
    <div class="row">
      <div class="rowtitle">音调</div>
      <div class="rowslider">
        <vue-slider
          v-model="pitch"
          :interval="1"
          :min="-100"
          :max="100"
          key=""
          :dot-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
          :process-style="{ backgroundColor: 'pink' }"
          :tooltip-style="{ backgroundColor: 'pink', borderColor: 'pink' }"
        ></vue-slider>
      </div>
    </div>
    <div class="row">
      <div class="rowtitle">音量</div>
      <div class="rowslider">
        <vue-slider
          v-model="volume"
          :interval="1"
          :min="0"
          :max="100"
          key=""
          :dot-style="{ backgroundColor: '#fff', borderColor: 'pink' }"
          :process-style="{ backgroundColor: 'pink' }"
          :tooltip-style="{ backgroundColor: 'pink', borderColor: 'pink' }"
        ></vue-slider>
      </div>
    </div>
    <div class="row">
      <div class="rowtitle">动作</div>
      <div class="rowslider">
        <Material
          :user="user.resobj ? user.resobj : user"
          :t9render="t9render"
          @selector="selector"
        ></Material>
      </div>
    </div>
    <div class="row_btn" v-if="parentName == 'AiLive'">
      <button class="button_line button_max" @click="shiting()">试听</button>
      <button v-if="backfuns" class="button_max" @click="queding()">
        确定
      </button>
    </div>
    <div class="row_btn" v-else>
      <button class="button_max" @click="shiting()">说话</button>
    </div>
    <div class="ttsloading" v-show="ttsloading">
      <img src="@/assets/images/20130527034916434.gif" />
      正在处理请稍后
    </div>
  </div>
</template>

<script>
import { uuid, } from '@/components/util/util_fun.js'


import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import Material from '@/views/selector/Material'
import { pinyin } from 'pinyin-pro'
import * as emotion from '@/components/xbot/emotion.js'
import { deepEqual } from 'assert'

export default {
  name: 'ttsbox',
  components: {
    VueSlider,

    Material
  },
  props: {
    parentName: { // 父组件名称
      type: String,
      default: 'ttsbox'
    },
    user: {
      type: Object,
      default: function () {
        return {}
      }
    }
    ,
    t9render: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ttsObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  inheritAttrs: false,// 取消默认行为
  data () {
    return {
      testtitle: '',
      titleMaxLength: 250,
      yusu: 1,//语速
      volume: 100,//音量
      pitch: 0,//语调
      emoji: [],
      myemoji: [],//这个用于存储当前角色拥有的情绪
      qiangdu: 0.5,//情绪强度
      ttsloading: false,//loading显示
      ttsurl: {},
      qingxulist: false,
      ttsrole: {},
      face: {},//当前选择的face
      hechengparm: {},//合成语音参数
      ttsdata: {}, //这是最终的结果
      anim: {},//选择的动作
      id: '',//这句话的id，用来编辑脚本中的语音·
      isEdit: false,//是否是编辑状态
      pid: '',// 商品组件id
    }
  },
  destroyed () {
    // console.log('ttsbox destroyed')
    this.$emit('clearTts')
  },
  created () {
    // console.log('生成语音的接收的user', this.user)
    this.emoji = emotion.emotion

    // console.log(this.user);
    if (this.user.tts) {
      //接受用户的配音状态
      this.ttsrole = JSON.parse(this.user.tts)
    }
    if (this.user.resobj.tts) {
      this.ttsrole = JSON.parse(this.user.resobj.tts)
    }
    // console.log('ttsboxCreated', this.ttsObj)
    if (this.ttsObj.text) {
      this.testtitle = this.ttsObj.text
    }
    if (this.ttsObj.id) {
      this.id = this.ttsObj.id
    }
    if (this.ttsObj.anim) {
      this.anim = this.ttsObj.anim
    }
    // console.log('是否带有情绪', this.ttsrole.emotion)

  },

  methods: {
    ttsId () {
      if (this.id != '') {
        this.isEdit = true
        return this.id
      } else {
        return uuid()
      }
    },
    queding () {
      if (!this.testtitle) {

        this.$message.warning("请先输入要说的话...")
        return
      }

      if (!this.ttsrole.language) {
        this.$message.warning("请选择配音员...")
        return
      }
      else //先合成，再回调
      {
        this.ttsloading = true
        this.hecheng().then((data) => {
          if (data) {
            this.ttsloading = false
            var ttscontant = {
              type: 1,
              id: this.ttsId(),
              pid: this.pid,
              text: this.testtitle,
              tts: data.url,
              dur: data.dur,//时长（单位秒）
              kx: this.pinyin2mouth(this.testtitle)
              //     emotion:"Joy", //情绪(Angry发怒\Fun享乐\Joy快乐\Neutral普通\Sorrow悲伤)
              //     strength:1,// 情绪强度(0-1)
            }
            if (this.face.hasOwnProperty('id')) {
              //把字符串根据空格转换成字符数组
              var arr = this.face.id.split(" ")
              //遍历字符数组
              for (var i = 0; i < arr.length; i++) {
                //把第一个字符变为大写,其余字符变为小写
                arr[i] = arr[i].slice(0, 1).toUpperCase() + arr[i].slice(1).toLowerCase()
              }
              ttscontant.emotion = arr.join(" ")
              ttscontant.strength = this.qiangdu
            }
            // ttscontant.user = this.user;
            ttscontant.anim = this.anim//动作
            this.ttsdata = ttscontant
            this.$emit('clearTts')
            this.$emit('backfun', this.ttsdata, this.isEdit)

          } else {
            this.ttsloading = false
            this.$message.error("当前角色配音员失效,请重新绑定")
          }
        }

        )

      }

    },
    shiting () {
      if (!this.testtitle) {
        this.$message.warning("请先输入要说的话...")
        return
      }
      // console.log('this.ttsrolebox', this.ttsrole)
      if (!this.ttsrole.language) {
        this.$message.warning("请选择配音员...")
        return
      }

      var modelid = this.user.rolesId
      this.ttsloading = true
      // console.log(this.t93d,this.user.rolesId);
      this.hecheng().then((data) => {
        console.log('合成的返回值', data)
        if (data) {
          this.ttsloading = false
          var ttscontant = {
            type: 1,
            id: this.ttsId(),
            pid: this.pid,
            text: this.testtitle,
            tts: data.url,
            dur: data.dur,
            kx: this.pinyin2mouth(this.testtitle)
            //     emotion:"Joy", //情绪(Angry发怒\Fun享乐\Joy快乐\Neutral普通\Sorrow悲伤)
            //     strength:1,// 情绪强度(0-1)
          }
          if (this.face.hasOwnProperty('id')) {
            //把字符串根据空格转换成字符数组
            var arr = this.face.id.split(" ")
            //遍历字符数组
            for (var i = 0; i < arr.length; i++) {
              //把第一个字符变为大写,其余字符变为小写
              arr[i] = arr[i].slice(0, 1).toUpperCase() + arr[i].slice(1).toLowerCase()
            }
            ttscontant.emotion = arr.join(" ")
            ttscontant.strength = this.qiangdu
          }
          ttscontant.user = this.user
          this.ttsdata = ttscontant


          console.log('ttscontant', [this.user.resobj, ttscontant])
          window.t9render.runfunction("speak", [ttscontant.user.resobj, ttscontant])//正常应该传资源对象，现在传当前角色
        } else {
          this.ttsloading = false
          this.$message.error("当前角色配音员失效,请重新绑定")
        }



      })
    },

    hecheng () { //合成语音，返回URL


      var param = {
        text: this.testtitle,
        language: this.ttsrole.language,
        rid: this.ttsrole.id,
        rate: this.yusu,//语速
        volume: this.volume,//音量
      }
      if (this.face.hasOwnProperty('id')) {
        param.style = this.face.id
        param.styledegree = this.qiangdu
      }
      var that = this

      //判断这个语音是否合成过
      if (JSON.stringify(this.hechengparm) === JSON.stringify(param)) {
        console.log('合成过了的音频')
        return new Promise((resolve, reject) => {
          resolve(that.ttsurl)
        })
      }
      else {
        this.hechengparm = param//记录合成语音
        return new Promise((resolve, reject) => {
          // console.log(param);
          this.post("/audiotts/tts", param).then((res) => {
            if (res.status == 200 && res.data) {
              console.log('合成的语音', res.data)
              that.ttsurl = res.data
              //获得音频时长
              let audio = document.createElement('audio') //生成一个audio元素 
              audio.src = that.ttsurl.url //音乐的路径 
              audio.addEventListener("canplay", () => {
                // console.log("音频长度=>>>：", parseInt(audio.duration) + '秒');
                res.data.dur = parseInt(audio.duration)
                resolve(res.data)
              })

            }
            else {
              // that.$message.error("合成失败")
              resolve()
            }

          })
        })
      }

    },
    mouseOver () { //情绪选择
      this.myemoji = []
      var tts = this.ttsrole
      console.log('情绪选择', tts)
      if (tts.emotion) {
        //将这个配音的全部情绪显示出来
        for (var i = 0; i < tts.emotion.length; i++) {
          var emojiname = tts.emotion[i]
          for (var j = 0; j < this.emoji.length; j++) {
            if (this.emoji[j].id == emojiname) {
              this.myemoji.push(this.emoji[j])
              break
            }
          }
        }

      }
      this.qingxulist = true
    },
    mouseLeave () {
      this.qingxulist = false
    },
    selface (face) { //选择情绪
      // console.log(face);
      if (face) {
        this.face = face
      }
      else {
        this.face = {}
      }

    },
    selector (obj) {
      //  console.log('选择内容',obj);
      this.anim = obj
    },
    /**
    * 通过对文本分析，获得口型集合
    */
    pinyin2mouth (text) {
      var mouth = []
      //将文本中的韵母拆出
      var yunmu = pinyin(text, { pattern: 'final', toneType: 'none', type: 'array' })
      // var shengmu = pinyin(text,{ pattern: 'initial', toneType: 'none', type: 'array' }); 
      // console.log("哈哈",yunmu);
      //根据韵母发音不同，对照进入5个原因口型
      var pipeibiao = {
        A: ["a", "an", "ia", 'ang', "2", "8"],//啊的因，大开
        E: ["i", "e", "ei", "ie", "en", "er", "eng", "1", "7"],//依的因，闭合拉宽
        I: ["ai", 'in', "ing", "3", "4", "0"],//和E差不多
        O: [],
        U: ["o", "ao", 'ui', "iao", "ong", "u", "ü", "üe", "ou", 'un', "uan", "ün", "5", "6", "9"]//优的因，嘟嘴
      }
      // var shengmubiao ={
      //     E:["z","c","s","y"],
      //     U:["w","r","zh","ch","sh"]
      // }
      for (var i = 0; i < yunmu.length; i++) {
        //插入声母口型
        // var zhaodao1 = false;
        // for(var key in shengmubiao){
        //     if(shengmubiao[key].indexOf(shengmu[i]) >=0)
        //     {
        //         mouth.push(key); //未识别口型
        //         zhaodao1 = true;
        //         break;
        //     }
        // }
        // if(!zhaodao1) //未识别口型，和闭口音
        // {
        //     mouth.push("O"); //未识别口型
        // }

        //插入韵母口型
        var zhaodao = false
        for (var key in pipeibiao) {
          if (pipeibiao[key].indexOf(yunmu[i]) >= 0) {
            mouth.push(key) //未识别口型
            zhaodao = true
            break
          }
        }
        if (!zhaodao) //未识别口型，和闭口音
        {
          mouth.push("O") //未识别口型
        }
      }
      return mouth
      // console.log(yunmu,this.mouth);
    }
  },
  directives: {
    sliceString: { //限制文字输入指令
      update (el, binding) {
        if (el.value.length >= binding.value) {
          el.value = el.value.slice(0, binding.value)
        }
      }
    }
  },
  computed: {
    backfuns () {
      //判断下是否需要显示确认按钮
      if (this.$listeners['backfun']) {
        return true
      }
      else {
        return false
      }
    },

  },
  watch: {
    user (val, oldVal) {
      // console.log("inputVal = " + val + " , oldValue = " + oldVal)
      this.ttsrole = JSON.parse(val.tts)
    },
    ttsObj: {
      handler: function (val, oldVal) {
        console.log('监听', val, oldVal)
        if (val.text) {
          this.testtitle = val.text
        } else {
          this.testtitle = ''
        }
        if (val.id) {
          this.id = val.id
        } else {
          this.id = ''
        }
        if (val.anim) {
          this.anim = val.anim
        } else {
          this.anim = ''
        }
        if (val.pid) { //当前编辑语句的商品id
          this.pid = val.pid
        } else {
          this.pid = ''
        }

      },
      // immediate: true

    }

  }
}
</script>

<style lang="scss" scoped>
$color-grey: #f5f5f5;
$color-pink: #f4acb7;
.tool_main {
  position: relative;

  .t9text {
    width: 90%;
    height: 130px;
    background-color: $color-grey;
    border: 0;
    padding: 5%;
    resize: none;
  }
  .emotion {
    width: 100px;
    margin-left: 10px;
    height: 32px;
    line-height: 32px;
    position: relative;
    i {
      font-size: 21px !important;
    }

    .emotion_list {
      display: flex;
      position: absolute;
      top: 30px;
      left: -80px;
      background-color: #fff;
      border: 1px $color-grey solid;
      padding: 10px;

      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      width: 240px;
      z-index: 999;
      line-height: 20px;

      span {
        width: 40px;
        height: 55px;
        text-align: center;
        font-size: 12px;
        cursor: pointer;

        .svg-icon {
          font-size: 21px;
          margin-bottom: 5px;
        }

        &:hover {
          color: $color-pink;
        }
      }
    }
  }
  .textlen {
    width: 300px;
    text-align: right;
    height: 32px;
    line-height: 32px;
  }
  .row_sele {
    width: 100%;
    height: 30px;
    line-height: 30px;
    background-color: $color-grey;
    border: 0;
  }
  .row {
    display: -webkit-flex;
    display: flex;
    padding: 10px 0;
    color: #585858;

    .seltts {
      width: 250px;
    }
    .rowtitle {
      width: 70px;
      // padding-left: 10px;
    }
    .rowslider {
      width: 300px;
    }
    .row_time {
      width: 30%;
      text-align: center;
      padding-top: 50px;
    }
    .row_btn {
      width: 40%;
      margin: 20px;
      text-align: center;
    }
    .row_restart {
      width: 30%;
      padding-top: 55px;
    }
  }
  .row_btn {
    margin: 20px;
    text-align: center;
  }
  .luzhi_btn {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #ffdce1;
    margin: 0 auto;
    position: relative;
    transition: all 0.5s ease;
    margin-bottom: 10px;

    .luzhi_btn_main {
      position: absolute;
      transition: all 0.5s ease;
      width: 90%;
      height: 90%;
      border-radius: 50%;
      margin: 5%;
      background-color: $color-pink;
      cursor: pointer;
    }
    &:hover .luzhi_btn_main {
      background-color: #fb5c74;

      transform: scale(0.4);
      border-radius: 10px;
    }
  }
  .ttsloading {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    color: #333;
    top: 0;
    left: 0;
    text-align: center;
    z-index: 999;
    img {
      display: block;
      width: 80px;
      margin: 20px auto;
      margin-top: 200px;
    }
  }
}
</style>